import {
  GET_YUSA_OVERNIGHT_CAMP_TOTAL_STAFF_DETAILS,
  GET_YUSA_OVERNIGHT_CAMP_WAGES_DETAILS,
  GET_YUSA_OVERNIGHT_CAMP_WAGES_ROLES_LIST,
  POST_YUSA_OVERNIGHT_CAMP_TOTAL_STAFF_DETAILS,
  POST_YUSA_OVERNIGHT_CAMP_WAGES_DETAILS
} from '@config/api-config';
import { asyncRequest } from '@config/http-config';
import * as types from './types';

// eslint-disable-next-line import/prefer-default-export
export const getOvernightCampDataTotalStaff =
  (branchNumber, reportBatchId, year) => (dispatch, getState) =>
    asyncRequest({
      url: GET_YUSA_OVERNIGHT_CAMP_TOTAL_STAFF_DETAILS(
        branchNumber,
        reportBatchId,
        year
      ),
      successAction: data => ({
        type: types.YUSA_OVERNIGHT_CAMP_GET_TOTAL_STAFF_SUCCESS,
        async: true,
        payload: data,
        state: getState()
      }),
      failureAction: error => ({
        type: types.YUSA_OVERNIGHT_CAMP_GET_TOTAL_STAFF_FAILURE,
        payload: error
      }),
      dispatch
    });

export const postOvernightCampDataTotalStaff =
  payloadBody => (dispatch, getState) =>
    asyncRequest({
      url: POST_YUSA_OVERNIGHT_CAMP_TOTAL_STAFF_DETAILS(),
      method: 'POST',
      data: payloadBody,
      successAction: data => ({
        type: types.YUSA_OVERNIGHT_CAMP_POST_TOTAL_STAFF_SUCCESS,
        async: true,
        payload: data,
        state: getState()
      }),
      failureAction: error => ({
        type: types.YUSA_OVERNIGHT_CAMP_POST_TOTAL_STAFF_FAILURE,
        payload: error
      }),
      dispatch
    });

export const getOvernightCampDataWagesList =
  (branchNumber, reportBatchId, year) => (dispatch, getState) =>
    asyncRequest({
      url: GET_YUSA_OVERNIGHT_CAMP_WAGES_DETAILS(
        branchNumber,
        reportBatchId,
        year
      ),
      successAction: data => ({
        type: types.YUSA_OVERNIGHT_CAMP_WAGES_SUCCESS,
        async: true,
        payload: data,
        state: getState()
      }),
      failureAction: error => ({
        type: types.YUSA_OVERNIGHT_CAMP_WAGES_FAILURE,
        payload: error
      }),
      dispatch
    });

export const getOvernightCampDataRolesList = () => (dispatch, getState) =>
  asyncRequest({
    url: GET_YUSA_OVERNIGHT_CAMP_WAGES_ROLES_LIST(),
    successAction: data => ({
      type: types.YUSA_OVERNIGHT_CAMP_ROLES_LIST_SUCCESS,
      async: true,
      payload: data,
      state: getState()
    }),
    failureAction: error => ({
      type: types.YUSA_OVERNIGHT_CAMP_ROLES_LIST_FAILURE,
      payload: error
    }),
    dispatch
  });

export const postOvernightCampDataWages = payloadBody => (dispatch, getState) =>
  asyncRequest({
    url: POST_YUSA_OVERNIGHT_CAMP_WAGES_DETAILS(),
    method: 'POST',
    data: payloadBody,
    successAction: data => ({
      type: types.YUSA_OVERNIGHT_CAMP_WAGES_LIST_SUCCESS,
      async: true,
      payload: data,
      state: getState()
    }),
    failureAction: error => ({
      type: types.YUSA_OVERNIGHT_CAMP_WAGES_LIST_FAILURE,
      payload: error
    }),
    dispatch
  });

export const resetReduxState = key => ({
  type: 'RESET_KEY',
  payload: { key }
});
